import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import BooleanInputField from "../../../components/forms/BooleanInputField";
import FormError from "../../../components/forms/FormError";

class UsTaxSettingForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>          
            <Field
              label="Deduct Shipping Cost"
              name="deductShippingCost"
              component={BooleanInputField}
              serverError={this.props.errors.deductShippingCost}
              />   
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "UsTaxSettingForm"
})(UsTaxSettingForm);

export default ReduxForm;